<template>
  <div v-if="targetsKeys.length > 0">
    Targets:
    <div v-for="oneKey in targetsKeys" :key="oneKey">
      <v-btn @click="selectedTarget(oneKey)">
        {{ targetDateForKey(oneKey) }} <br />
        {{ targetStringForKey(oneKey) }}
      </v-btn>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import {bus} from "../../../main";

export default {
  name: "ProjectTopCardTargets",
  props: ["targets", "projectId"],
  computed: {
    targetsKeys() {
      return this.targets ? Object.keys(this.targets) : [];
    },
  },
  methods: {
    targetDateForKey(oneKey) {
      const build = this.targets[oneKey].build;
      const buildKey = Object.keys(build)[0];
      return new Date(buildKey * 1000).toDateString();
    },
    targetStringForKey(oneKey) {
      let title = "" + this.targets[oneKey].title;
      const build = this.targets[oneKey].build;
      const buildKey = Object.keys(build)[0];

      const buildDetails = build[buildKey];
      let errorCode = "🟢";
      if (buildDetails.errorCode < 0) {
        errorCode = "🔴";
      } else if (buildDetails.errorCode > 0) {
        errorCode = "🟡";
      }

      return `${errorCode} ${title} ${buildDetails.statusText} `;
    },
    selectedTarget(targetId) {
      const projectId = this.projectId;
      bus.emit("projecttop-targetselected", {projectId, targetId});
    },
  },
};
</script>
<style scoped></style>
